import {
  APP_INITIALIZER,
  ApplicationConfig,
  ErrorHandler,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter, Router } from '@angular/router';

import { routes } from './app.routes';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_FAB_DEFAULT_OPTIONS } from '@angular/material/button';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr,
} from '@angular/common/http';
import { HttpListenerInterceptor } from './interceptors/http-listener-interceptor';
import { ProjectConfiguration } from './utils/ProjectConfiguration';
import { ViewPath } from './constants/ViewPath';
import { endpoints } from './constants/Endpoints';
import { GlobalCacheConfig, LocalStorageStrategy } from 'ts-cacheable';
import * as Sentry from '@sentry/angular';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'outline',
        color: 'primary',
        subscriptSizing: 'dynamic',
      },
    },
    { provide: MAT_FAB_DEFAULT_OPTIONS, useValue: { color: 'p3' } },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: HttpListenerInterceptor, multi: true },

    // Sentry
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
};

export const projectConfiguration = new ProjectConfiguration({
  landingView: ViewPath.login,
  errorView: ViewPath.pageNotFound,
  dashboardView: ViewPath.dashboard,
  errorHandlerEndpoint: endpoints.reportError,
  checkVersionEndpoint: undefined,
});

// Configuración global para ts-cacheable
GlobalCacheConfig.storageStrategy = LocalStorageStrategy; // Persistente
GlobalCacheConfig.maxAge = 10 * 60 * 1000; // 10 minutos por defecto
GlobalCacheConfig.maxCacheCount = 100;
